<script>

import axios from "axios";

import { Doughnut } from "vue-chartjs";

import dataStore from "../store";

import chartColors from '../../chart-colors'

export default {

    extends: Doughnut,

    inject: [ 'language' ],

    props: {
        slug: String,
        project: Object,
        item: Object
    },

    data() {
        return {
            dataStore
        };
    },

    mounted() {

        this.getStats();

        document.addEventListener('chartRerender', e => {

            if(this.dataStore.collectedAnswers.length > 0 && e.detail) {

                try {
                    this.renderMe(this.dataStore.collectedAnswers, 0)
                } catch(error) {}

            } else {
                this.getStats();
            }
        })
    },

    methods: {

        getStats: function() {

            axios.post(`/api/get-stats`, { project_slug: this.project.slug, item_id: this.item.id, slug: this.slug })
            .then(res => {
                if (!res.data) return;

                try {
                    this.renderMe(res.data, this.slug)
                } catch(error) {}

            })
            .catch(err => {
                console.error(err);
            });

        },

        renderMe: function(data, key) {

            let labelsFromDb = Object.keys(data[key]);
            const selectedType = data[key];

            if (labelsFromDb.includes("man")) {
                labelsFromDb = [this.language.male, this.language.female, this.language.other];
            } else if (labelsFromDb.includes("good")) {
                labelsFromDb = [this.language.good, this.language.improve];
            }

            if( labelsFromDb === null || selectedType === null ) return;

            const allowRender = Object.values(selectedType).some(val => val > 0)

            if(!allowRender) return;

            const values = Object.values(selectedType);

            if(values === undefined) return;

            let options = {
                labels: labelsFromDb,
                datasets: [
                    {
                        backgroundColor: chartColors,
                        data: values
                    }
                ]
            };

            let settings = {
                legend: {
                    position: "top",
                    labels: {},
                    usePointStyle: true,
                    onClick: (e) => e.stopPropagation()
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                maintainAspectRatio: true,
                responsive: false,
                animation: {
                    duration: 0
                },

                plugins: {
                    datalabels: {
                        formatter: (value, ctx) => {
                            return null
                        }
                    }
                },

                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {

                            const dataset = data.datasets[tooltipItem.datasetIndex];

                            const total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            const currentValue = dataset.data[tooltipItem.index];
                            const precentage = Math.round( ( ( currentValue / total ) * 100 ) );

                            return`${precentage}%`
                        }
                    }

                }

            };

            // Remove labels above if either only good or bad
            if(key === 'good_bad' && ( (this.item.allow_good_options && !this.item.allow_bad_options) || (!this.item.allow_good_options && this.item.allow_bad_options) ) ) {
                settings = Object.assign(settings, { legend: { display: false } })
            }

            this.renderChart(options, settings);
        }

    }
};
</script>
